
function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    const drawerElement = this.querySelector('#filter-drawer-button');

    document.addEventListener('click', (event) => {
        if (!drawerElement.contains(event.target)) {
            this.querySelector('#filter-drawer').classList.add('hidden');  
            document.querySelector('body').classList.remove('overflow-hidden');
        }
    })

    const toggleDrawer = (e) => {
        e.preventDefault();

        let drawer = this.querySelector('#filter-drawer');

        if (drawer.classList.contains('hidden')) {
            drawer.classList.remove('hidden');
            document.querySelector('body').classList.add('overflow-hidden');
        } else {
            drawer.classList.add('hidden');
            document.querySelector('body').classList.remove('overflow-hidden');
        }
        drawer.scrollIntoView({ behavior: 'smooth' });
    };

    drawerElement.addEventListener('click', toggleDrawer);
    drawerElement.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') toggleDrawer(e);
    });
    if (!drawerElement.getAttribute('tabindex')) drawerElement.setAttribute('tabindex', '0');
    drawerElement.setAttribute('role', 'button');

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForms = this.querySelectorAll('form');
    facetForms.forEach((facetForm) => {
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    });

    const facetDrawers = this.querySelectorAll('#FacetFiltersForm .js-filter');
    facetDrawers.forEach((facetDrawer) => {
        const toggleButton = facetDrawer.querySelector('button');
        const filterDrawer = facetDrawer.querySelector('.filter-drawer');
        if (!toggleButton || !filterDrawer) return;

        const setFilterOpen = (open) => {
            filterDrawer.classList.toggle('hidden', !open);
            toggleButton.setAttribute('aria-expanded', open ? 'true' : 'false');
        };

        const toggleFilter = (event) => {
            event.preventDefault();
            event.stopPropagation();
            setFilterOpen(filterDrawer.classList.contains('hidden'));
        };

        toggleButton.addEventListener('click', toggleFilter);
        toggleButton.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                toggleFilter(e);
            }
        });

        document.addEventListener('click', (event) => {
            if (!facetDrawer.contains(event.target)) {
                setFilterOpen(false);
            }
        })
    })


    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      })
      .catch(() => {
        const grid = document.getElementById('ProductGridContainer');
        if (grid) grid.querySelector('.collection')?.classList.remove('loading');
        const count = document.getElementById('ProductCount');
        if (count) count.classList.remove('loading');
        const countDesktop = document.getElementById('ProductCountDesktop');
        if (countDesktop) countDesktop.classList.remove('loading');
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const loadedHtml = new DOMParser().parseFromString(html, 'text/html');

    const countDesktop = loadedHtml.getElementById('ProductCountDesktop').innerHTML;
    const count = loadedHtml.getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = countDesktop;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    //document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

// ---------- Quick Buy variant matrix fix ----------
// The compiled form-quick-buy element updates the hidden variant ID, but the
// server-rendered <option disabled> state can be wrong for products with
// multiple option axes (for example Flavor + Bag Size). Keep option availability
// in sync with the embedded variant JSON so a valid size is not stuck disabled
// after switching flavor.
(function () {
  function getQuickBuyVariants(panel) {
    if (panel._quickBuyVariants) return panel._quickBuyVariants;
    const script = panel.querySelector('script[type="application/json"]');
    if (!script) return [];

    try {
      panel._quickBuyVariants = JSON.parse(script.textContent || '[]');
    } catch (error) {
      panel._quickBuyVariants = [];
    }

    return panel._quickBuyVariants;
  }

  function getQuickBuySelects(panel) {
    return Array.from(panel.querySelectorAll('select[name^="option"]'));
  }

  function getQuickBuyOptionIndex(control) {
    const match = control && control.name && control.name.match(/^option(\d+)$/);
    return match ? Number(match[1]) - 1 : -1;
  }

  function getQuickBuySelectedOptions(panel, overrideControl, overrideValue) {
    const options = [];
    panel.querySelectorAll('input[name^="option"], select[name^="option"]').forEach((control) => {
      const index = getQuickBuyOptionIndex(control);
      if (index < 0) return;
      options[index] = control === overrideControl ? overrideValue : control.value;
    });
    return options;
  }

  function formatQuickBuyMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD',
      currencyDisplay: 'narrowSymbol',
    }).format((cents || 0) / 100);
  }

  function normalizeQuickBuyOptionLabel(option, isAvailable) {
    const baseLabel = option.dataset.baseLabel || option.textContent.replace(/\s+- Sold Out\s*$/i, '').trim();
    option.dataset.baseLabel = baseLabel;
    option.textContent = isAvailable ? baseLabel : `${baseLabel} - Sold Out`;
  }

  function findQuickBuyVariant(variants, selectedOptions) {
    return variants.find((variant) => {
      return variant.options && variant.options.every((value, index) => selectedOptions[index] === value);
    });
  }

  function getQuickBuyCard(panel) {
    return panel.closest('.relative.group') || panel.parentElement;
  }

  function getQuickBuyVariantImage(variant) {
    return variant && (variant.featured_image || variant.image || null);
  }

  function getSizedQuickBuyImageUrl(url, width) {
    if (!url) return '';
    if (url.indexOf('width=') !== -1) return url.replace(/([?&])width=\d+/, `$1width=${width}`);
    return `${url}${url.indexOf('?') === -1 ? '?' : '&'}width=${width}`;
  }

  function updateQuickBuyCardMedia(panel, selectedVariant) {
    const card = getQuickBuyCard(panel);
    const image = card && card.querySelector('[data-quick-buy-card-image]');
    const link = card && card.querySelector('[data-quick-buy-card-link]');
    const desktopTitle = card && card.querySelector('[data-quick-buy-card-title-desktop]');
    const mobileTitle = card && card.querySelector('[data-quick-buy-card-title-mobile]');
    if (!card || !selectedVariant) return;

    if (link && link.href) {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', selectedVariant.id);
      link.href = url.toString();
    }

    const displayTitle = (link && link.dataset.listingTitle) || selectedVariant.name;
    if (displayTitle && desktopTitle) desktopTitle.textContent = displayTitle;
    if (displayTitle && mobileTitle) mobileTitle.textContent = displayTitle;

    const variantImage = getQuickBuyVariantImage(selectedVariant);
    const imageUrl = typeof variantImage === 'string' ? variantImage : variantImage && variantImage.src;
    if (!image || !imageUrl) return;

    image.src = getSizedQuickBuyImageUrl(imageUrl, 533);
    image.srcset = [165, 360, 533, 720, 940, 1066]
      .map((width) => `${getSizedQuickBuyImageUrl(imageUrl, width)} ${width}w`)
      .join(', ');
    image.alt = selectedVariant.name || image.alt;
  }

  function syncQuickBuyPanel(panel) {
    const variants = getQuickBuyVariants(panel);
    const selects = getQuickBuySelects(panel);
    if (!variants.length || !selects.length) return;

    selects.forEach((select) => {
      const selectOptionIndex = getQuickBuyOptionIndex(select);
      if (selectOptionIndex < 0) return;

      Array.from(select.options).forEach((option) => {
        const candidateOptions = getQuickBuySelectedOptions(panel, select, option.value);
        const isAvailable = variants.some((variant) => {
          if (!variant.available || !variant.options) return false;
          return variant.options.every((value, optionIndex) => {
            if (optionIndex > selectOptionIndex) return true;
            return candidateOptions[optionIndex] === value;
          });
        });

        option.disabled = !isAvailable;
        normalizeQuickBuyOptionLabel(option, isAvailable);
      });

      if (select.selectedOptions[0] && select.selectedOptions[0].disabled) {
        const firstAvailableOption = Array.from(select.options).find((option) => !option.disabled);
        if (firstAvailableOption) select.value = firstAvailableOption.value;
      }
    });

    const selectedOptions = getQuickBuySelectedOptions(panel);
    const selectedVariant = findQuickBuyVariant(variants, selectedOptions);
    const idInput = panel.querySelector('[name="id"]');
    const price = panel.querySelector('.price');
    const submit = panel.querySelector('[type="submit"]');

    if (selectedVariant && idInput) idInput.value = selectedVariant.id;
    if (selectedVariant && price) price.innerHTML = formatQuickBuyMoney(selectedVariant.price);
    updateQuickBuyCardMedia(panel, selectedVariant);

    if (submit) {
      if (!selectedVariant || !selectedVariant.available) {
        submit.setAttribute('disabled', 'disabled');
      } else {
        submit.removeAttribute('disabled');
      }
    }
  }

  function syncAllQuickBuyPanels(root) {
    root.querySelectorAll('form-quick-buy').forEach(syncQuickBuyPanel);
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest('form-quick-buy select[name^="option"]');
    if (!select) return;
    syncQuickBuyPanel(select.closest('form-quick-buy'));
  });

  document.addEventListener('quick-buy:opened', (event) => {
    syncQuickBuyPanel(event.detail.panel);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncAllQuickBuyPanels(document));
  } else {
    syncAllQuickBuyPanels(document);
  }

  document.addEventListener('facet:updated', () => syncAllQuickBuyPanels(document));
})();
// ---------- end Quick Buy variant matrix fix ----------
